import axios from '@/api/axios'

const getUserList = (data) => {
    return axios
        .post(`/admin/user/users-list`, {user: data})
        .then(response => response.data)
}

const getAdminList = (data) => {
    return axios
        .post(`/admin/user/users`, {user: data})
        .then(response => response.data)
}


const updateUser = (data) => {
    return axios
        .post(`/admin/user/update`, {user: data})
        .then(response => response.data)
}

const logout = (data) => {
    return axios
        .post(`/admin/user/logout`, {user: data})
        .then(response => response.data)
}


export default {
    getUserList,
    updateUser,
    getAdminList,
    logout

}
